module.exports = __webpack_public_path__ + "media/images/loading-a50c46f5739030fc24f73d088e000684.png";